/* intro.js — LA PUERTA y la secuencia completa.

   Orden: puerta (decides) → intro (presentación · acercamiento · despeje) → tienda.
   Nada se mueve ni suena antes de que el visitante elija: ni partículas, ni música, ni
   contenido. Eso arregla el "todo aparece al mismo tiempo".

   Y hay una razón dura detrás de la puerta, no solo estética: los navegadores BLOQUEAN el
   audio hasta que hay un gesto del usuario. El clic en «entrar con música» ES ese gesto.
   Así la música suena de verdad, sin trucos y sin pelear con el navegador.

   Todo lo construye este script: sin JavaScript la tienda se ve normal y se puede comprar
   (progressive enhancement — nunca dejamos la tienda detrás de una pantalla que no carga). */
(function () {
  var K = window.KAWAII || {};
  var cfg = K.intro || {};
  var letrero = document.getElementById('intro-letrero');
  var nubes = document.getElementById('intro-nubes');
  var escena = document.getElementById('escena') || document.querySelector('main');
  var puerta = null;

  function quitarCapas() {
    [letrero, nubes, puerta].forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function avisar() {
    try { document.dispatchEvent(new CustomEvent('kawaii:listo')); } catch (e) {
      var ev = document.createEvent('Event'); ev.initEvent('kawaii:listo', true, true);
      document.dispatchEvent(ev);
    }
  }

  // El despeje se REPARTE en varios frames. Todo junto en un solo tick era la causa del
  // parpadeo en móvil: se destruía la capa de compositor de .escena, se creaban 9-12 capas
  // nuevas de partículas y se repintaba la página entera, todo en el mismo frame. Un
  // teléfono no traga eso de una vez.
  function despues(pasos, fn) {           // n frames más tarde, sin bloquear nada
    if (!window.requestAnimationFrame) return void setTimeout(fn, pasos * 16);
    (function paso(i) {
      requestAnimationFrame(i <= 0 ? fn : function () { paso(i - 1); });
    })(pasos);
  }

  function listo() {                     // revela la tienda y avisa a los demás scripts
    // El despeje ya es opacidad pura (la tienda no se mueve ni se escala), así que no hay
    // capa de compositor que proteger: quitar las clases no desmonta nada de golpe.
    document.body.classList.remove('intro-corriendo');
    document.body.classList.add('kawaii-listo');
    if (escena) {
      escena.classList.remove('emerge');
      escena.style.animationDelay = '';
      escena.style.willChange = 'auto';
    }
    // Las partículas (una capa cada una) entran un par de frames después, para no competir
    // con el frame en que la tienda queda revelada.
    despues(2, avisar);
  }

  var menos = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var yaVista = false;
  try { yaVista = sessionStorage.getItem('kawaii_intro') === '1'; } catch (e) { }

  // Ya entró en esta visita (o pidió menos movimiento): no se le vuelve a preguntar.
  if (menos || (cfg.unaVez && yaVista && !K.editando)) { quitarCapas(); listo(); return; }

  document.body.classList.add('intro-corriendo');

  if (cfg.puerta) construirPuerta(); else correrIntro(false);

  // ── LA PUERTA ────────────────────────────────────────────────────────────
  function construirPuerta() {
    puerta = document.createElement('div');
    puerta.className = 'puerta';
    puerta.setAttribute('role', 'dialog');
    puerta.setAttribute('aria-label', cfg.puertaTexto || 'Elige cómo entrar');
    puerta.innerHTML =
      '<div><div class="puerta-marca"></div>' +
      '<p class="puerta-texto"></p>' +
      '<div class="puerta-botones">' +
      '<button type="button" data-musica="1"></button>' +
      '<button type="button" data-musica="0"></button>' +
      '</div></div>';
    var marca = puerta.querySelector('.puerta-marca');
    if (K.logoImg) {                         // tu logo manda también en la puerta
      var img = document.createElement('img');
      img.src = K.logoImg; img.alt = K.tienda || ''; img.className = 'puerta-logo';
      marca.appendChild(img);
    } else {
      marca.textContent = K.tienda || document.title;
    }
    puerta.querySelector('.puerta-texto').textContent = cfg.puertaTexto || '¿Cómo quieres entrar?';
    var bs = puerta.querySelectorAll('button');
    bs[0].textContent = cfg.puertaCon || '🔊 Entrar con música';
    bs[1].textContent = cfg.puertaSin || '🔇 Entrar en silencio';
    puerta.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-musica]');
      if (b) decidir(b.getAttribute('data-musica') === '1');
    });
    document.body.appendChild(puerta);
    bs[0].focus();
  }

  function decidir(conMusica) {
    try {
      localStorage.setItem('kawaii_musica', JSON.stringify({ on: conMusica, t: 0, ts: Date.now() }));
    } catch (e) { }
    if (puerta) puerta.classList.add('sale');
    window.setTimeout(function () {
      if (puerta && puerta.parentNode) puerta.parentNode.removeChild(puerta);
      puerta = null;
      correrIntro(conMusica);
    }, 430);
  }

  // ── LA INTRO ─────────────────────────────────────────────────────────────
  function correrIntro(conMusica) {
    // El clic de la puerta es el gesto que el navegador pedía: aquí ya puede sonar.
    if (conMusica && window.kawaiiMusica) { try { window.kawaiiMusica.encender(); } catch (e) { } }

    if (!cfg.activa || !letrero || !nubes) { quitarCapas(); listo(); marcarVista(); return; }

    var dur = (parseFloat(cfg.duracion) || 5) * 1000;
    document.body.appendChild(letrero);        // fuera de .escena: el transform del despeje
    document.body.appendChild(nubes);          // rompería su position:fixed

    // fase 1 · PRESENTACIÓN
    letrero.style.animation = 'present ' + (dur * 0.72) + 'ms ease forwards';

    // fase 2 · ACERCAMIENTO — las nubes brotan del punto de fuga hacia la cámara
    var cuantas = parseInt(cfg.nubes, 10); if (isNaN(cuantas)) cuantas = 11;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < cuantas; i++) {
      var n;
      if (K.nubeImg) { n = document.createElement('img'); n.src = K.nubeImg; n.alt = ''; n.className = 'intro-nube propia'; }
      else { n = document.createElement('div'); n.className = 'intro-nube'; }
      var ang = Math.random() * 6.28, dist = 60 + Math.random() * 45;
      n.style.setProperty('--tx', (Math.cos(ang) * dist) + 'vw');
      n.style.setProperty('--ty', (Math.sin(ang) * dist) + 'vh');
      n.style.animation = 'flythrough ' + (dur * 0.42 + Math.random() * dur * 0.24) + 'ms ease-in forwards';
      n.style.animationDelay = (dur * 0.19 + Math.random() * dur * 0.3) + 'ms';
      frag.appendChild(n);
    }
    nubes.appendChild(frag);

    // fase 3 · DESPEJE — la tienda ENTERA se desvanece a la vista, quieta en su sitio.
    // Nada de transform-origin ni escala: solo opacidad (la raíz del parpadeo era mover
    // la página entera en móvil). Empieza mientras las nubes aún despejan.
    if (escena) {
      escena.classList.add('emerge');
      escena.style.animationDelay = (dur * 0.49) + 'ms';
    }

    window.setTimeout(function () { quitarCapas(); listo(); marcarVista(); }, dur + 400);
  }

  function marcarVista() {
    try { sessionStorage.setItem('kawaii_intro', '1'); } catch (e) { }
  }
})();
